export enum ColorTheme {
  RED = 'red',
  BLUE = 'blue',
}
